export default __webpack_public_path__ + "img/check.png?4499";